import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { About } from './components/About';
import { MissionVisionValues } from './components/MissionVisionValues';
import { Team } from './components/Team';
import { Process } from './components/Process';
import { Differentiators } from './components/Differentiators';
import { Commitment } from './components/Commitment';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-white font-sans antialiased" data-id="element-0" data-mp="31agn4l9h89hv">
      <Header data-id="element-1" data-mp="31ctf7r8y808n" />
      <main data-id="element-2" data-mp="2wk09b01quluz">
        <Hero data-id="element-3" data-mp="2wk9y4kb1ymz3" />
        <TrustBar data-id="element-4" data-mp="2wjqg73lejyl2" />
        <About data-id="element-5" data-mp="2wj8f9tnsow6t" />
        <MissionVisionValues data-id="element-6" data-mp="2wip7v6vrtq71" />
        <Team data-id="element-7" data-mp="28ufoscpxzgjl" />
        <Process data-id="element-8" data-mp="28tw5arkn8k3g" />
        <Differentiators data-id="element-9" data-mp="28te1n9vnj3li" />
        <Commitment data-id="element-10" data-mp="28sl3gxardmez" />
        <Contact data-id="element-11" data-mp="28s2zfehuu3wi" />
      </main>
      <Footer data-id="element-12" data-mp="23vuoyeelqyvo" />
    </div>;
}